<template>
  <!-- ════ GRAND PRIZE ════ -->
  <section id="grand-prize">
    <!-- Signature: Golden Ticket foil catch (see .ticket-glow CSS). Remove to disable. -->
    <div class="ticket-glow" aria-hidden="true"></div>
    <canvas class="ticket-motes" aria-hidden="true"></canvas>
    <div class="section-inner">
      <div class="grand-prize-inner">
        <div class="grand-prize-content">
          <p class="eyebrow reveal">Grand Prize</p>
          <h2 class="headline reveal d1">An Extraordinary Adventure Awaits</h2>
          <p class="body-copy reveal d2">One lucky winner and a guest will travel to Las Vegas for an unforgettable trip
            to <b>Netflix House</b>, where immersive experiences and imagination come to life.
          </p>
          <div class="reveal d3" style="display:flex;gap:12px;flex-wrap:wrap;align-items:center;">
            <a href="/Upload" class="btn-gold">Enter Now<svg class="btn-icon" width="15" height="15"
                viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
                <path d="M2.5 8H13M9.5 4.5L13 8L9.5 11.5" stroke="currentColor" stroke-width="2" stroke-linecap="round"
                  stroke-linejoin="round"></path>
              </svg></a>
            <a href="#" class="btn-outline-light js-pd-open" data-pd-tab="grand">View Prize Details</a>
          </div>
        </div>
      </div>
    </div>
    <!-- B-bottom: high-left → low-right. Fill = lavender. -->

  </section>


  <!-- ════ HOW TO ENTER ════ -->
  <section id="how-to-enter">
    <div class="scene-fill" aria-hidden="true">
      <div></div>
    </div>
    <div class="scene-cap" aria-hidden="true">
      <div></div>
    </div>
    <canvas class="how-motes" aria-hidden="true"></canvas>
    <div class="section-inner">
      <div class="how-to-enter-inner">
        <div class="how-card reveal">
          <span class="glint-top" aria-hidden="true"></span>
          <span class="how-glow" aria-hidden="true"></span>
          <p class="eyebrow">How To Enter</p>
          <h2 class="headline" style="font-size:clamp(26px,3vw,38px);color:#fff;">Your Journey<br>Through the Factory
          </h2>
          <p class="body-copy" style="color:#fff;">Four simple steps stand between you and a world filled with wonder,
            adventure, and extraordinary prizes.</p>
          <div class="steps-grid">
            <div class="step">
              <img src="https://snippcheck.blob.core.windows.net/files/WKKC_Golden_Ticket_2008937/images/step1.png" class="step-badge" alt="Step 1">
              <div class="step-label">Find The Magic</div>
              <p class="step-desc">Purchase limited-edition <b>Kellogg's<sup>&reg;</sup> Cocoa Loops featuring Wonka Hat Marshmallows</b>.</p>
            </div>
            <div class="step">
              <img src="https://snippcheck.blob.core.windows.net/files/WKKC_Golden_Ticket_2008937/images/step2.png" class="step-badge" alt="Step 2">
              <div class="step-label">Upload Receipt</div>
              <p class="step-desc">Submit your <b>qualifying receipt</b> through this promotional site through <b>1/14/27</b>.</p>
            </div>
            <div class="step">
              <img src="https://snippcheck.blob.core.windows.net/files/WKKC_Golden_Ticket_2008937/images/step3.png" class="step-badge" alt="Step 3">
              <div class="step-label">Earn Your Entry</div>
              <p class="step-desc">Every qualifying purchase earns a sweepstakes entry.*</p>
            </div>
            <div class="step">
              <img src="https://snippcheck.blob.core.windows.net/files/WKKC_Golden_Ticket_2008937/images/step4.png" class="step-badge" alt="Step 4">
              <div class="step-label">You Could Win</div>
              <p class="step-desc">Unlock your chance to win unforgettable prizes inspired by Wonka's world.</p>
            </div>
          </div>
          <div class="how-cta">
            <a href="/Upload" class="btn-gold">Upload Your Receipt<svg class="btn-icon" width="15" height="15"
                viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
                <path d="M2.5 8H13M9.5 4.5L13 8L9.5 11.5" stroke="currentColor" stroke-width="2" stroke-linecap="round"
                  stroke-linejoin="round"></path>
              </svg></a>
            <a href="#" class="product-link js-pp-open">View Participating Products <span class="chev">&rsaquo;</span></a>
          </div>
          <p class="how-fine-print">*Each qualifying purchase earns one sweepstakes entry, up to 5 entries per receipt. Maximum of 25 entries per participant. No Purchase Necessary. See <a href="http://snipp.us/!cuYZN" target="_blank" rel="noopener" style="color:var(--gold);text-decoration:underline;text-underline-offset:2px;font-style:italic;">Official Rules</a> for details.</p>
          
        </div>
      </div>
    </div>
    <!-- A-bottom: low-left → high-right. Fill = product purple. -->

  </section>


  <!-- ════ PRODUCT — BEGIN YOUR ADVENTURE ════ -->
  <section id="product">
    <!-- Optional badge shimmer overlay (see .badge-shimmer CSS). Remove to disable. -->
    <div class="badge-shimmer" aria-hidden="true"></div>
    <!-- Mobile-only Wonka Hat badge, laid over the lower-left of the mobile scene.
       Needs a transparent PNG at assets/images/wonka-hat-badge.png. -->
    <img class="product-badge" src="https://snippcheck.blob.core.windows.net/files/WKKC_Golden_Ticket_2008937/images/wonka-hat-badge.png" alt="With Wonka Hat Marshmallows"
      onerror="this.style.display='none'">
    <div class="section-inner">
      <div class="product-inner">
        <div class="product-content">
          <p class="eyebrow reveal">Begin Your Adventure</p>
          <h2 class="headline reveal d1">Adventure Begins<br>With <span style="white-space:nowrap;">The <span style="color:var(--gold);">First Box</span></span></h2>
          <p class="body-copy reveal d2" style="max-width:430px;color:#FFFFFF;">Purchase limited-edition <b>Kellogg's<sup>&reg;</sup> Cocoa Loops featuring Wonka Hat Marshmallows</b>, upload your <b>qualifying receipt</b>, and take your first step toward extraordinary prizes.</p>
          <div class="product-actions reveal d3"
            style="display:flex;flex-direction:column;align-items:flex-start;gap:2px;">
            <a href="/Upload" class="btn-gold">Upload Your Receipt<svg class="btn-icon" width="15" height="15"
                viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
                <path d="M2.5 8H13M9.5 4.5L13 8L9.5 11.5" stroke="currentColor" stroke-width="2" stroke-linecap="round"
                  stroke-linejoin="round"></path>
              </svg></a>
            <a href="#" class="product-link js-pp-open" id="pp-open">View Participating Product <span
                class="chev">&rsaquo;</span></a>
          </div>
        </div>
      </div>
    </div>
    <!-- B-bottom: high-left → low-right. Fill = secondary lavender. -->

  </section>


  <!-- ════ SECONDARY PRIZE ════ -->
  <section id="secondary-prize">
    <div class="scene-fill" aria-hidden="true">
      <div></div>
    </div>
    <div class="scene-cap" aria-hidden="true">
      <div></div>
    </div>
    <div class="scene-light" aria-hidden="true"></div>
    <canvas class="secondary-motes" aria-hidden="true"></canvas>
    <div class="section-inner">
      <div class="secondary-inner">
        <div class="secondary-card reveal">
          <span class="glint-top" aria-hidden="true"></span>
          <span class="how-glow" aria-hidden="true"></span>
          <div class="pill">20 Lucky Winners</div>
          <p class="eyebrow eyebrow--on-light" style="color:var(--gold);">Secondary Prize</p>
          <h2 class="headline" style="font-size:clamp(28px,3.2vw,44px);color:#fff;">Breakfast<br>Just Got More<br>Chocolatey.</h2>
          <p class="body-copy" style="color:#fff;">Twenty lucky winners will receive <strong>their choice of four Kellogg’s cereal favorites</strong>, bringing a little extra wonder to every breakfast ahead.</p>
          <div class="secondary-btns">
            <a href="/Upload" class="btn-gold">Upload Your Receipt<svg class="btn-icon" width="15" height="15"
                viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
                <path d="M2.5 8H13M9.5 4.5L13 8L9.5 11.5" stroke="currentColor" stroke-width="2" stroke-linecap="round"
                  stroke-linejoin="round"></path>
              </svg></a>
            <a href="#" class="btn-outline-light js-pd-open" data-pd-tab="secondary">View Prize Details</a>
          </div>
        </div>
      </div>
    </div>
    <!-- A-bottom: low-left → high-right. Fill = FAQ purple. -->

  </section>


  <!-- ════ FAQ ════ -->
  <section id="faq">
    <div class="section-inner">
      <div class="faq-inner-wrap">
        <div class="faq-grid">
          <div class="faq-left">
            <p class="eyebrow reveal">FAQ</p>
            <h2 class="headline reveal d1" style="font-size:clamp(28px,3.2vw,44px);color:var(--white);">Frequently Asked<br>Questions</h2>
            <p class="body-copy reveal d2" style="color:var(--muted-dark);">Need a little guidance? Explore answers to the most common questions about the Golden Ticket sweepstakes.</p>
          </div>
          <div class="faq-list reveal">
            <div class="faq-item">
              <button class="faq-question" aria-expanded="false">
                <span class="faq-q-text">What if I am having trouble participating in a program?</span>
                <span class="faq-icon">+</span>
              </button>
              <div class="faq-answer">
                <div class="faq-answer-inner">For assistance, please visit our <a href="https://www.wkkellogg.com/contact-us" target="_blank" rel="noopener">Contact Us</a> page and our team will be happy to help.</div>
              </div>
            </div>
            <div class="faq-item">
              <button class="faq-question" aria-expanded="false">
                <span class="faq-q-text">What are the participating products?</span>
                <span class="faq-icon">+</span>
              </button>
              <div class="faq-answer">
                <div class="faq-answer-inner">Look for the limited-edition <b>Kellogg's<sup>&reg;</sup> Cocoa Loops cereal featuring magical Wonka Hat Marshmallows</b>. <a href="#" class="js-pp-open">View eligible product details</a> or <a href="https://www.wkkellogg.com/where-to-buy#/US/any/product/f58b19d8-8f05-4023-8c06-42dc55c385eb/9.2oz?dtr-selectedFilter={%22tags%22:%22Froot%20Loops%22}" target="_blank" rel="noopener">find a participating retailer near you</a> to begin your quest for the Golden Ticket. <a href="http://snipp.us/!cuYZN" target="_blank" rel="noopener">Click here</a> to view more details.</div>
              </div>
            </div>
            <div class="faq-item">
              <button class="faq-question" aria-expanded="false">
                <span class="faq-q-text">How long do I have to send in my receipt?</span>
                <span class="faq-icon">+</span>
              </button>
              <div class="faq-answer">
                <div class="faq-answer-inner">Participants must submit their eligible receipt(s) before <b>11:59 PM ET on 1/14/27</b>. Purchases must be made between <b>8/17/26 and 12/31/26</b>. You have until 1/14/27 at 11:59 PM ET to upload your receipt.</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>
<script>
import { onMounted } from 'vue';

export default {
  props: {
    startDate: {
      type: Date,
      required: true,
    },
    endDate: {
      type: Date,
      required: true,
    },
  },
  data() {
    return {};
  },
  setup() {
    // Setup FAQ accordion after component mounts
    onMounted(() => {
      // FAQ accordion
      document.querySelectorAll('.faq-question').forEach(btn => {
        btn.addEventListener('click', () => {
          const item = btn.closest('.faq-item');
          const answer = item.querySelector('.faq-answer');
          const isOpen = item.classList.contains('open');
          document.querySelectorAll('.faq-item').forEach(el => {
            el.classList.remove('open');
            el.querySelector('.faq-answer').style.maxHeight = null;
            el.querySelector('.faq-question').setAttribute('aria-expanded', 'false');
          });
          if (!isOpen) {
            item.classList.add('open');
            answer.style.maxHeight = answer.scrollHeight + 'px';
            btn.setAttribute('aria-expanded', 'true');
          }
        });
      });

      // Hash-based scroll navigation
      (function () {
        var id = (location.hash || "").replace(/^#/, "");
        if (!id || id.charAt(0) === "/") return;
        if ("scrollRestoration" in history) history.scrollRestoration = "manual";
        // layout-based offset (immune to .reveal transforms, unlike getBoundingClientRect)
        function offsetTop(el) { var y = 0; while (el) { y += el.offsetTop; el = el.offsetParent; } return y; }
        function go(smooth) {
          var el = document.getElementById(id); if (!el) return;
          window.scrollTo({ top: Math.max(0, offsetTop(el) - 60), behavior: smooth ? "smooth" : "auto" });
        }
        window.scrollTo(0, 0);
        // run once layout is up, then correct again as images/fonts settle the page height
        window.addEventListener("load", function () {
          requestAnimationFrame(function () { go(true); });
          setTimeout(function () { go(true); }, 350);
          setTimeout(function () { go(false); }, 900);
        });
        if (document.fonts && document.fonts.ready) document.fonts.ready.then(function () { go(false); });
      })();
    });

    return {};
  }
};
</script>

<style scoped>

</style>


